import { Injectable } from '@angular/core';

import { OfferCategory } from '@cds/betting-offer';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Observable, map, of } from 'rxjs';

import { SportsCacheService } from '../../../../client-caching/sports-cache.service';
import { EventSwitcherToggleService } from '../event-switcher-toggle.service';
import { IEventSwitcherToggleHelperService } from './event-switcher-toggle-helper.service';

@Injectable()
export class EventSwitcherToggleHelperRowService implements IEventSwitcherToggleHelperService {
    constructor(
        private sportCacheService: SportsCacheService,
        private toggleService: EventSwitcherToggleService,
    ) {}

    openSwitcher(event: EventModel): void {
        if (!this.toggleService.expanded && event) {
            this.toggleService.openSwitcher(event);
        } else {
            this.toggleService.close();
        }
    }

    closeSwitcher(): void {
        this.toggleService.close();
    }

    getCount(event: EventModel): Observable<number> {
        if (event.offerCategories.some((c) => [OfferCategory.Outrights].includes(c))) {
            return of(0);
        }

        return this.sportCacheService.getSport(event.sport.id, event.league.id).pipe(
            map((sport) => {
                if (event.live) {
                    return sport?.counts.live ?? 0;
                }

                const count = sport?.children.find((region) => region.id === event.region.id);

                return count ? count.counts.gridable : 0;
            }),
        );
    }

    get expanded$(): Observable<boolean> | undefined {
        return this.toggleService.expanded$;
    }
}
